export const formatTechServiceLocation = (techService) => {
  if (!techService) {
    return 'Konum bilgisi yok';
  }

  // Debug: Gelen veriyi kontrol et (sadece development'ta)
  if (process.env.NODE_ENV === 'development') {
    console.log('[formatTechServiceLocation] Tech service data:', {
      techService,
      il: techService.il,
      ilce: techService.ilce,
      cityId: techService.cityId,
      districtId: techService.districtId,
    });
  }

  // İl bilgisini al
  let city = '';
  
  // İl objesi varsa içinden isim al
  if (techService.il && typeof techService.il === 'object') {
    city = techService.il.name || techService.il.ad || techService.il.title || '';
  }
  
  // Diğer olası formatlar
  if (!city && techService.sehir && typeof techService.sehir === 'object') {
    city = techService.sehir.name || techService.sehir.ad || '';
  }
  
  if (!city && techService.city && typeof techService.city === 'object') {
    city = techService.city.name || techService.city.ad || '';
  }
  
  if (!city && techService.cityName) {
    city = techService.cityName;
  }

  // İlçe bilgisini al
  let district = '';
  
  // İlçe objesi varsa içinden isim al
  if (techService.ilce && typeof techService.ilce === 'object') {
    district = techService.ilce.name || techService.ilce.ad || techService.ilce.title || '';
  }
  
  // Diğer olası formatlar
  if (!district && techService.district && typeof techService.district === 'object') {
    district = techService.district.name || techService.district.ad || '';
  }
  
  if (!district && techService.districtName) {
    district = techService.districtName;
  }

  // İsimleri birleştir
  const parts = [];
  if (city && city.trim().length > 0) {
    parts.push(city.trim());
  }
  if (district && district.trim().length > 0 && district.trim() !== city.trim()) {
    parts.push(district.trim());
  }

  if (parts.length > 0) {
    return parts.join(' / ');
  }

  // İsim yoksa "Konum bilgisi yok" döndür (ID gösterme)
  return 'Konum bilgisi yok';
};

